module.exports = __webpack_public_path__ + "static/media/collaborators.e32da60e.jpg";